function convertStonesToGrams(num){
  let eq = 'Converting ' + num +" stones to grams: \n"+
    num +" / 0.00015747 = ";
  let rep = num / 0.00015747;
  return eq + rep.toFixed(6);
}

function convertStonesToOunces(num){
  let eq = 'Converting ' + num +" stones to ounces: \n"+
    num +" * 224 = ";
  let rep = num * 224;
  return eq + rep.toFixed(2);
}

function convertStonesToPounds(num){
  let eq = 'Converting ' + num +" stones to pounds: \n"+
    num + " * 14 = ";
  let rep = num *  14;
  return eq + rep.toFixed(2);
}

function convertStonesToKilograms(num){
  let eq = 'Converting ' + num +" stones to kilograms: \n"+
    num + " / 0.15747 = ";
  let rep = num / 0.15747 ;
  return eq + rep.toFixed(3);
}

export {
  convertStonesToKilograms, convertStonesToPounds, convertStonesToOunces,
  convertStonesToGrams};
